import React from 'react';

import css from './Address.module.css';

const Address = () => (
    <address className={css.Address}>
        Aquavital Hrvatska<br />
        Dubrava 215<br />
        10040 Grad Zagreb<br />
        <br />
        +385 98 9197 810<br />
        <a href = "mailto: aquavital@net.hr">aquavital@net.hr</a>
    </address>
);

export default Address;